'use client';
import { FC } from 'react';

import { PlpFilterQueryParams } from '@/types/CarFilters.types';

import { SearchAlertTileLowResults } from '../SearchAlertTile/SearchAlertTileLowResults';
import { SearchAlertTileNoResults } from '../SearchAlertTile/SearchAlertTileNoResults';
import { SearchAlertToggle } from '../SearchAlertToggle/SearchAlertToggle';
import { SearchAlertToggleProvider } from '../SearchAlertToggle/SearchAlertToggleProvider';

type Props = {
  filterParams?: PlpFilterQueryParams;
  sku?: string;
  placement: 'tile' | 'page-top';
  plpSlug: string;
  savedSearchTypesenseQuery: {
    q: string;
    filter_by: string;
    page: number;
  };
};

export const ResultsSearchAlertToggle: FC<Props> = ({
  filterParams,
  sku,
  placement,
  plpSlug,
  savedSearchTypesenseQuery,
}: Props) => {
  const getToggleComponent = () => {
    if (placement === 'tile') {
      return sku ? SearchAlertTileLowResults : SearchAlertTileNoResults;
    }
    return SearchAlertToggle;
  };

  return (
    <SearchAlertToggleProvider
      filters={filterParams}
      Component={getToggleComponent()}
      placement={placement}
      targetSlug={plpSlug}
      savedSearchTypesenseQuery={savedSearchTypesenseQuery}
    />
  );
};
